import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useAtomValue } from 'jotai';
import { useResetAtom } from 'jotai/utils';
import React, { useCallback } from 'react';

import { Alert, Modal } from '~/components/blocks';
import { outpatientQuestionnaireSendUnavailableModalState } from '~/state/reception/atoms';

const ErrorAlert = styled(Alert)(({ theme }) =>
  css({
    padding: `${theme.space.m} ${theme.space.l}`,
    fontSize: theme.fontSizes.m,
    status: 'error',
  }),
);

export const SendUnavailableModal = () => {
  const { isOpen } = useAtomValue(outpatientQuestionnaireSendUnavailableModalState);
  const resetOutpatientQuestionnaireSendUnavailableModalState = useResetAtom(
    outpatientQuestionnaireSendUnavailableModalState,
  );
  const handleClose = useCallback(() => {
    resetOutpatientQuestionnaireSendUnavailableModalState();
  }, [resetOutpatientQuestionnaireSendUnavailableModalState]);

  return (
    <Modal open={isOpen} size="s" onClose={handleClose}>
      <Modal.Header>通知を送信できませんでした</Modal.Header>
      <Modal.Body>
        <ErrorAlert>
          LINE公式アカウント無料メッセージ配信上限に到達したため、通知機能はご利用になれません。
          <br />
          患者にご連絡の際は電話などをご利用ください
        </ErrorAlert>
      </Modal.Body>
    </Modal>
  );
};
